export default "__VITE_PUBLIC_ASSET__a7dac1d2__"